export const constants = {
    SET_JWT : 'set_jwt_token',
    SET_USER : 'set_user',
    LOG_OUT : 'user_logged_out',
    SET_PRODUCTS : 'set_products',
    SET_STORES : 'set_stores',
    ADD_TO_CART : 'add_to_cart',
    REMOVE_FROM_CART : 'remove_from_cart',
    UPDATE_CART : 'update_cart',
    CLEAR_CART : 'clear_cart'
}